import type { FaireProductEntity } from "../../entity_types/product";

export const p_cxqz8atatw: FaireProductEntity = {
  token: "p_cxqz8atatw",
  type: "product",
  name: "Vitamatic 60mg Melatonin | Sugar Free | 60 Veggie Gummies",
  brandToken: "b_cptgb5am9n",
  brandName: "Vitamatic",
  imageUrl:
    "https://cdn.faire.com/fastly/98795de0bad37de8f357795678845b3303d4c3c21a60de3428bf161aad841861.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ceffee4472e20f6497e82f00e14a8ceb38c96841aa8deed39de127cf6566b8c.jpeg",
    "https://cdn.faire.com/fastly/6d7ab691247165d5013b5290c5fabe730b9479247908fd00688546505fb3476a.jpeg",
    "https://cdn.faire.com/fastly/7332955f27987062fb4be4bc52e6b2d1737c09280b8b0ef249d67a1ea7885066.jpeg",
    "https://cdn.faire.com/fastly/710a999fff68119d0d1e4333f0915129545078c30cf5b9313a38ac08e26c2077.jpeg",
    "https://cdn.faire.com/fastly/cef45b1a982e1c7656da7a44e7f0f2d814260cfe14d4415a0ef7d453c41939ed.jpeg",
    "https://cdn.faire.com/fastly/3641c07944e6b79a831058f19623206762ab284bfce010ab5535d7de9a524400.jpeg",
    "https://cdn.faire.com/fastly/039fd1348f9704c0f04bb739049599f2a246481a09508230e040ab85a1ba96f3.jpeg",
    "https://cdn.faire.com/fastly/6919bcbeccfe8353786536ebbd21c86fffd11337341bad3325817f84bf2dce79.png",
    "https://cdn.faire.com/fastly/91c596779fc8f47ab43bd1735134efd91e532eaa400867efdacbc63e99ff38af.png",
  ],
  priceDollars: 11.99,
  description:
    "Enhance your sleep quality with Vitamatic Sugar-Free Melatonin 60 mg. Each vegetarian gummy delivers 60 mg of melatonin, a natural sleep aid that helps regulate your sleep-wake cycle, promoting deep, restful sleep. These 60 sugar-free gummies are non-habit forming, making them a safe and effective option for those seeking natural sleep support. Made with natural, non-GMO ingredients, these gummies offer a convenient, great-tasting way to improve your sleep routine without added sugar or artificial additives. With 60 servings per bottle, you’ll have a full month’s supply of melatonin to help you unwind and relax every night.\n\nDelicious Natural Strawberry Flavor.\n\n100% Drug Free - High Potency Melatonin Gummies.\n\nVEGAN FRIENDLY - Our Melatonin Gummies are pectin-based which is vegan & vegetarian friendly.\n\nFree of soy, yeast, wheat, egg, artificial color, flavor, & preservatives.\n\nDIFFERENT FORM MELATONIN – Melatonin comes in many forms, including gummies, capsules, chewable, drops, Tablets and liquid - Gummy is the most pleasant tasting formula which delivers 10 mg per daily serving.",
  tags: [],
  msrpDollars: 23.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:38.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
